export const getWhatsAppNumbers = state => state.resources.phoneNumbers.whatsappNumbers;
export const getWhatsAppNumbersRequestStatus = state => state.resources.phoneNumbers.whatsappNumbersRequestStatus;